import React from 'react';
import PropTypes from 'prop-types';
import Cookies from "js-cookie";
import helpers from '../../resources/helpers';

import HiddenInput from '../form-elements/HiddenInput';
import CheckBoxInput from '../form-elements/CheckBoxInput';

import './GDPRChoices.scss';

class GDPRChoices extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: true,
			inEU: true,
		};
		this.updateInEu = this.updateInEu.bind(this);
	}

	componentDidMount() {
		if (!this.props.alwaysShow) {
			this.updateInEu();
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.countryOverride !== this.props.countryOverride) {
			this.updateInEu();
		}
	}

	async updateInEu() {
		const inEU = await helpers.checkIfInEU(this.props.countryOverride);
		const gdprAccepted = Cookies.get('gdpr_form_accepted');
		this.setState({
			visible: !gdprAccepted,
			inEU,
		});
	}

	render() {
		return (
			<React.Fragment>
				{this.state.visible && (
					<React.Fragment>
						<HiddenInput name="hasGDPR" value={true} />

						{this.state.inEU ? (
							<CheckBoxInput
								label={
									this.props.marketingConsentLabel ||
									'I acknowledge that I am opting in to receive communications from Esri on topics such as news, resources, products, and events.'
								}
								optionalLabel={this.props.optionalLabel}
								name="marketingConsent"
								required={this.props.required}
								errorMessage={
									this.props.errorMessage ||
									'You must acknowledge that you are opting in to receive communications from Esri on topics such as news, resources, products, and events.'
								}
								formHasHadAnInValidSubmit={this.props.formHasHadAnInValidSubmit}
							/>
						) : (
							<HiddenInput name="marketingConsent" value={true} />
						)}
					</React.Fragment>
				)}
				<div className="gdpr_conf_message">
					{this.props.submitAgreementMsg || (
						<React.Fragment>
							By submitting this form, you confirm that you have read and agree to{' '}
							<a target="_blank" href="https://www.esri.com/en-us/privacy/privacy-statements/privacy-statement">
								Esri’s Privacy Statements.
							</a>
						</React.Fragment>
					)}
				</div>
			</React.Fragment>
		);
	}
}

GDPRChoices.propTypes = {
	optionalLabel: PropTypes.string,
	countryOverride: PropTypes.string,
	submitAgreementMsg: PropTypes.any,
	marketingConsentLabel: PropTypes.string,
	errorMessage: PropTypes.string,
	alwaysShow: PropTypes.bool,
	required: PropTypes.bool,
	formHasHadAnInValidSubmit: PropTypes.bool,
};

export default GDPRChoices;
